module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "transform": _vm.translate
    }
  }, [_c('g', {
    attrs: {
      "id": _vm.field,
      "width": _vm.width
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97a36b38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LegendChart.vue
// module id = 380
// module chunks = 1